export interface IconProps {
  className?: string
}

export default function CloseIcon({ className }: IconProps) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M1 1L10.9991 10.9991" stroke="white" />
      <path d="M11 1L1.00091 10.9991" stroke="white" />
    </svg>
  )
}
